import * as moment from "moment";

const ajusteZeros = (n: number) => ('00' + n).slice(-2);

const tratarData = (date: Date | number) => {
  if (typeof date === 'number') {
    date = new Date(date);
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  return date;
};

export const dateToString = (date: Date | number) => {
  if (!date) {
    return '';
  }

  date = tratarData(date);

  const dataFinal = {
    dia: date.getDate(),
    mes: date.getMonth() + 1,
    ano: date.getFullYear()
  };
  return `${ajusteZeros(dataFinal.dia)}/${ajusteZeros(dataFinal.mes)}/${dataFinal.ano}`;
};

export const timeToString = (date: Date) => {
  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return `${ajusteZeros(date.getHours())}:${ajusteZeros(date.getMinutes())}:${ajusteZeros(date.getSeconds())}`;
};

export const dateToTimeString = (date: Date) => {
  date = tratarData(date);
  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return `${ajusteZeros(date.getHours())}:${ajusteZeros(date.getMinutes())}`;
};

export const dateTimeToString = (date: Date) => {
  date = tratarData(date);
  if (!date) {
    return '';
  }
  const {dia, mes, ano} = {dia: date.getDate(), mes: date.getMonth() + 1, ano: date.getFullYear()};
  return `${ajusteZeros(dia)}/${ajusteZeros(mes)}/${ano} ${timeToString(date)}`;
};

export const dateToStringPadrao = (date: Date) => {
  if (!date) {
    return '';
  }
  date = tratarData(date);
  const {dia, mes, ano} = {dia: date.getDate(), mes: date.getMonth() + 1, ano: date.getFullYear()};
  return `${ajusteZeros(dia)}-${ajusteZeros(mes)}-${ano}`;
};

export const timeToStringHHMM = (date: Date | number) => {
  if (!date) {
    return '';
  }

  const dataFinal: Date = tratarData(date);

  return `${ajusteZeros(dataFinal.getHours())}:${ajusteZeros(dataFinal.getMinutes())}`;
};

export const stringToTime = (hora: string) => {
  if (!hora) {
    return null;
  }

  try {
    const data = new Date();
    const valores = hora.split(':');
    data.setSeconds(0);
    data.setHours(Number.parseInt(valores[0]));
    data.setMinutes(Number.parseInt(valores[1]));
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const stringToDate = (data: string): Date => {
  if (!data) {
    return null;
  }
  try {
    const [dia, mes, ano] = data.split('/');
    const [diaNumber, mesNumber, anoNumber] = [Number(dia), Number(mes) - 1, Number(ano)];

    const dataDate = new Date(anoNumber, mesNumber, diaNumber);

    if (dataDate.getDate() === diaNumber && dataDate.getMonth() === mesNumber && dataDate.getFullYear() === anoNumber) {
      return dataDate;
    }
  } catch {

    return null;
  }
  return null;
};

export const longToDate = (date: number): Date => {
  let data: Date;
  if (date) {
    data = new Date(date);
  }
  return data;
};


export const segundosToMilisegundos = (segundos: number): number => {
  return segundos * 1000;
};


export const convertDurationToTimeString = (duration: number): string => {
  const totalSeconds = Math.floor(duration);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const timeString = [hours, minutes, seconds].map(unit => String(unit).padStart(2, '0')).join(':');
  return timeString;
};


export const compararSeHoraInicialMaiorOuIgualHoraFinal = (horaInicial: string, horaFinal: string) => {
  if (
    !horaInicial ||
    !horaFinal ||
    !horaInicial.trim() ||
    !horaFinal.trim()
  ) {
    return true;
  }
  const [horaInicialHH, horaInicialMM] = horaInicial.split(':');
  const [horaFinalHH, horaFinalMM] = horaFinal.split(':');
  const horaInicialNumber = Number(horaInicialHH) * 60 + Number(horaInicialMM);
  const horaFinalNumber = Number(horaFinalHH) * 60 + Number(horaFinalMM);
  if (horaInicialNumber >= horaFinalNumber) {
    return true;
  }

  return false;
};

export const getPlusDate = (dataInicial: Date, qtdDias: number, hora?: string): Date => {
  const dataFinal = new Date();
  dataFinal.setDate(dataInicial.getDate() + qtdDias);
  if (hora) {
    const tempo = hora.split(':');
    dataFinal.setHours(Number.parseInt(tempo[0]), Number.parseInt(tempo[1]));
  }
  return dataFinal;
};

export const quantidadeDiasEntreDatas = (dataInicial, dataFinal): number => {
  const diferencaEmMilissegundos = Math.abs((dataFinal - dataInicial));
  const milissegundosEmUmDia = 1000 * 60 * 60 * 24;
  return Math.floor(diferencaEmMilissegundos / milissegundosEmUmDia);
};


export  const exibirDataNoFuso = (dataMiliSegudnos ) => {
  const dataLocal = new Date(dataMiliSegudnos);
  const deslocamentoFuso = dataLocal.getTimezoneOffset() * 60000
    + (3 * 3600000);
  const dataNoFuso = new Date(dataLocal.getTime() + deslocamentoFuso);
  const dataFormatada = dataNoFuso.toISOString().replace('T', ' ').substring(0, 19);
  return dataFormatada;
};

export const aplicarHorarioToDateAndCompararDataAtual = (data: Date, horario: string) => {
  const dataAgendamento: Date = new Date(data);
  const horaSplit: string[] = horario.split(':');
  dataAgendamento.setHours(Number(horaSplit[0]), Number(horaSplit[1]));
  return dataAgendamento > new Date();
};

export const converterParaHoras = (horarioString: string) => {
  const [horas, minutos] = horarioString.split(':').map(Number);
  return horas + minutos / 60;
};

export const adicionarDiminuirMesesDataAtual = (qtdMeses: number, tipo: string = 'diminuir'): Date => {
  if (tipo === 'adicionar') {
    return new Date(new Date().setMonth(new Date().getMonth() + qtdMeses));
  }
  return new Date(new Date().setMonth(new Date().getMonth() - qtdMeses));
};

export const isDentroOuIntersecaIntervalo = (inicioPeriodo: string, fimPeriodo: string, inicioIntervaloRef: string, fimIntervaloRef: string) => {
  const inicioPeriodoTime = moment(inicioPeriodo, 'HH:mm');
  const fimPeriodoTime = moment(fimPeriodo, 'HH:mm');
  const inicioIntervaloTime = moment(inicioIntervaloRef, 'HH:mm');
  const fimIntervaloTime = moment(fimIntervaloRef, 'HH:mm');

  return inicioPeriodoTime.isBefore(fimIntervaloTime) && inicioIntervaloTime.isBefore(fimPeriodoTime);
};

export const gerarRangeDatas = (dataInicio: string | Date, dataFim: string | Date): Date[] => {
  const resultado: Date[] = [];

  const inicio = new Date(dataInicio);
  const fim = new Date(dataFim);

  inicio.setHours(0, 0, 0, 0);
  fim.setHours(0, 0, 0, 0);

  while (inicio <= fim) {
    resultado.push(new Date(inicio));
    inicio.setDate(inicio.getDate() + 1);
  }

  return resultado;
};

export const getMinutosTotais = (horario: string): number => {
  const [horas, minutos] = horario.split(':').map(Number);
  return (horas * 60) + minutos;
};


/**
 * Adiciona uma quantidade de dias a uma data específica ou à data atual.
 * @param dias O número de dias a adicionar.
 * @param dataBase (Opcional) A data de referência. Se omitida, usa a data atual.
 * @returns Um novo objeto Date com os dias adicionados.
 */
export const adicionarDias = (dias: number, dataBase: Date = new Date()): Date => {
  const novaData = new Date(dataBase.getTime());
  novaData.setDate(novaData.getDate() + dias);
  return novaData;
};

export const checarPeriodoMaximoEntreDatas = (dataInicio, dataFim, periodoDias) => {
  const umDiaEmMilissegundos = 24 * 60 * 60 * 1000;
  const diffEmDias = Math.round((dataFim - dataInicio) / umDiaEmMilissegundos);
  return diffEmDias < periodoDias;
};


/**
 * Retorna uma nova data baseada na data atual menos a quantidade de dias informada.
 * @param dias Quantidade de dias a ser subtraída
 * @returns Objeto Date com a data calculada
 */
export const obterDataRetroativa = (dias: number): Date => {
  const data = new Date();
  data.setDate(data.getDate() - dias);
  return data;
};


export const quantidadeDiasEmRota = (dataInicial, dataFinal): number => {
  const diferencaEmMilissegundos = Math.abs((dataFinal - dataInicial));
  const milissegundosEmUmDia = 1000 * 60 * 60 * 24;
  return Math.ceil(diferencaEmMilissegundos / milissegundosEmUmDia);
};

export const exibirDataHoraNoFuso = (dataMiliSegundos) => {
  const dataFormatada = exibirDataNoFuso(dataMiliSegundos);

  if (!dataFormatada) {
    return dataFormatada;
  }

  const [data, hora] = dataFormatada.split(' ');
  const [ano, mes, dia] = data.split('-');

  return `${dia}/${mes}/${ano} ${hora.substring(0, 5)}`;
};
